const styles = {
	picker: {
		width: '100% !important',
		marginTop: '2rem'
	},
	addColorButton: {
		width: '100%',
		padding: '1rem',
		marginTop: '1rem',
		fontSize: '1rem'
	},
	colorNameInput: {
		width: '100%',
		height: '50px'
	}
};

export default styles;
